export var BitgetOrderStatusEnum;
(function (BitgetOrderStatusEnum) {
    BitgetOrderStatusEnum["PENDING"] = "pending";
    BitgetOrderStatusEnum["SUBMITTING"] = "submitting";
    BitgetOrderStatusEnum["INIT"] = "init";
    BitgetOrderStatusEnum["NEW"] = "new";
    BitgetOrderStatusEnum["PARTIAL_FILL"] = "partial_fill";
    BitgetOrderStatusEnum["FULL_FILL"] = "full_fill";
    BitgetOrderStatusEnum["CANCELLED"] = "cancelled";
    BitgetOrderStatusEnum["FAILED"] = "failed";
})(BitgetOrderStatusEnum || (BitgetOrderStatusEnum = {}));
//# sourceMappingURL=bitget-order-status.enum.js.map